import { GridColDef } from '@mui/x-data-grid-pro';

import { mapGridIndexes } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';
import { PhoenixGrid } from '@shared/components/grid/PhoenixGrid';
import { uniqueItems } from '@shared/utils/helpers';
import { GridWrapper } from '@styles/GridStyles';

import { ILoanToValue } from '../interfaces';

interface ILoanToValueProps {
  data?: ILoanToValue[];
}

const titleCaseString = (title: string) => title    
.replace(/(_|-)/g, ' ')
.trim()
.replace(/\w\S*/g, function(str) {
  return str.charAt(0).toUpperCase() + str.substr(1);
})   
.replace(/([a-z])([A-Z])/g, '$1 $2')
.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');    

export const LoanToValue = ({ data }: ILoanToValueProps) => {
	const getColumns = () => {
		const columns: GridColDef[] = [];
		if (data && data.length > 0) {
			columns.push(dataGridCol('ltvType', { headerName: 'LTV' }));
			const headers = uniqueItems(data, 'valuation');
			const columnOrder = ['KbbRetail', 'KbbWholesale', 'NadaRetail', 'NadaTradeIn', 'KbbFinanceExpress'];
			const sortedHeaders = [...headers].sort(
				(a, b) => columnOrder.indexOf(a) - columnOrder.indexOf(b)
			);

            sortedHeaders.forEach((h) => {
				const updatedTextName = h.replace('Nada', 'JDPower');
				columns.push(dataGridCol(h, { headerName: titleCaseString(updatedTextName) }));
			});
		}
	
		return columns.map((column) => ({...column, flex: 1}));
	};

	const getRowData = () => {
		// Have to use *any* here as column header and data needs to genearted dynamically fron the api data
		const rowData: unknown[] = [];
		if (data && data.length > 0) {
			const ltvs = uniqueItems(data, 'ltvType');
			ltvs.forEach((l) => {
				const row: { [key: string]: string } = { ltvType: l };
				data
					.filter((d) => d.ltvType === l)
					.forEach((dt) => {
						row[dt.valuation] = dt.ltvValue;
					});
				rowData.push(row);
			});
		}
		return rowData;
	};

	const rows = [
		{
			ltv: 'Front End',
			kbbRetail: 87.39,
			kbbWholesale: 94.43,
			nadaRetail: 'N/A',
			nadaTradeIn: 'N/A'
		},
		{
			ltv: 'All In',
			kbbRetail: 87.39,
			kbbWholesale: 94.43,
			nadaRetail: 'N/A',
			nadaTradeIn: 'N/A'
		}
	];

	return (
		<GridWrapper>
			<PhoenixGrid
				strict
				canNotCopy
				withHeader
				noButton
				hideFooter
				autoHeight
				disableSelectionOnClick
				name="Loan To Value"
				columns={getColumns()}
				loading={!rows}
				rows={mapGridIndexes(getRowData())}
			/>
		</GridWrapper>
	);
};
